import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { cn } from "@/utils/cn";

interface DashboardCardProps {
  title: string;
  icon: string;
  actionLabel?: string;
  actionTo?: string;
  className?: string;
  children: ReactNode;
}

export default function DashboardCard({
  title,
  icon,
  actionLabel,
  actionTo,
  className,
  children,
}: DashboardCardProps) {
  return (
    <section
      className={cn(
        "flex flex-col rounded-lg border border-background-200 bg-background-50",
        className
      )}
    >
      <header className="flex items-center justify-between gap-3 border-b border-background-200 px-4 py-3.5 md:px-5">
        <div className="flex min-w-0 items-center gap-2.5">
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-secondary-50 text-secondary-600">
            <i className={cn(icon, "text-base")} aria-hidden="true" />
          </span>
          <h2 className="truncate font-heading text-sm font-semibold text-foreground-950 md:text-base">
            {title}
          </h2>
        </div>
        {actionLabel && actionTo && (
          <Link
            to={actionTo}
            className="inline-flex shrink-0 items-center gap-0.5 whitespace-nowrap text-xs font-label font-medium text-primary-700 transition-colors hover:text-primary-800 cursor-pointer"
          >
            {actionLabel}
            <i className="ri-arrow-right-s-line text-base" aria-hidden="true" />
          </Link>
        )}
      </header>
      <div className="flex-1 p-4 md:p-5">{children}</div>
    </section>
  );
}